module.exports = {
      id: "android-block-usage",
      viewBox: "0 0 114 35",
      url: "/" + "sprite-4add775381efce29ef76f223dff77c00.svg#android-block",
      toString: function () {
        return this.url;
      }
    }